import type { ColDef, GridOptions } from 'ag-grid-community';

import type { TypeFailItem } from '~/types/receive.types';

/**
 * [입고관리 > 입고요청관리] 입고요청등록 모달 > 엑셀 추가 실패 모달 테이블
 */
const getReceiveExcelUploadFailModalColumnDefs = ({
  data,
  hasPermissionNFA,
}: {
  data: TypeFailItem[];
  hasPermissionNFA: boolean;
}) => {
  const columnDefs: ColDef<TypeFailItem>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'goodsCode',
      headerName: '상품코드',
      width: 140,
    },
    {
      hide: !hasPermissionNFA,
      field: 'nsid',
      headerName: 'NSID',
      width: 180,
    },
    {
      field: 'manufactureDate',
      headerName: '제조일자',
      width: 100,
    },
    {
      field: 'expirationDate',
      headerName: '유통/소비기한',
      width: 110,
    },
    {
      field: 'palletYn',
      headerName: '파렛트 사용여부',
      width: 120,
    },
    {
      field: 'boxQty',
      headerName: '수량(BOX)',
      width: 100,
    },
    {
      field: 'boxPerQty',
      headerName: '입수(BOX당)',
      width: 100,
    },
    {
      field: 'eachQty',
      headerName: '수량(EA)',
      width: 100,
    },
    {
      field: 'failReason',
      headerName: '실패사유',
      minWidth: 700,
      flex: 1,
    },
  ];

  return { columnDefs };
};

export default getReceiveExcelUploadFailModalColumnDefs;
